<div class="layout-topbar">
  <div class="topbar-start">
    <button #menubutton type="button" class="topbar-menubutton p-link p-trigger" (click)="onMenuButtonClick()">
      <i class="pi" [ngClass]="layoutService.state.staticMenuMobileActive ? 'pi-times' : 'pi-bars'"></i>
    </button>

    <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
  </div>

  <div *ngIf="!layoutService.isDesktop()" class="topbar-middle">
    <app-logo></app-logo>
  </div>

  <div class="topbar-end">
    <ul class="topbar-menu">
      <!-- Trial Days Remaining (Web only) -->
      <li *ngIf="layoutService.isDesktop() && trialDaysRemaining !== null && trialDaysRemaining !== undefined" class="trial-days-container">
        <span class="trial-days-text">{{ trialDaysRemaining }} μέρες δοκιμής</span>
      </li>
      <!-- Upgrade to Premium Button (Web only, shown during trial) -->
      <li
        *ngIf="layoutService.isDesktop() && trialDaysRemaining !== null && trialDaysRemaining !== undefined"
        class="upgrade-button-container"
      >
        <button pButton type="button" class="upgrade-button p-button-rounded" (click)="onUpgradeButtonClick()">
          <i class="pi pi-bolt"></i>
          <span>Αναβάθμιση σε Premium</span>
        </button>
      </li>
      <li *ngIf="canViewNotifications" class="ml-3">
        <button
          pButton
          type="button"
          icon="pi pi-bell"
          class="notifications-icon p-button-text p-button-secondary p-button-rounded flex-shrink-0"
          (click)="onNotificationButtonClick($event)"
        ></button>
        <p-overlayPanel #notificationPanel [dismissable]="true" styleClass="notifications-overlay-panel">
          <oms-notifications-popover></oms-notifications-popover>
        </p-overlayPanel>
      </li>
      <li class="topbar-profile">
        <button type="button" pButton pRipple class="p-button-text p-button-rounded" (click)="onProfileButtonClick()">
          <p-avatar [style]="{ display: 'flex', width: '32px', height: '32px' }" [image]="avatarBase64" shape="circle"></p-avatar>
        </button>
      </li>
    </ul>
  </div>
</div>
